import React from 'react';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { CurrencyCode } from 'further-types/lp/vehicle';
import AdvanceSubscriptionsContent from './AdvanceSubscriptionsContent';
import { CalendarDay } from 'further-ui/utils';
import { useFormContext } from 'react-hook-form';
import { PartnerTransfersFormValues } from '../../hooks/usePartnerTransfersForm';

const TransferAdvanceSubscriptions: React.FC<{
  partnerTransferId: string;
  baseCurrency: CurrencyCode;
  onNext: () => void;
  onPrevious: () => void;
}> = ({ partnerTransferId, baseCurrency, onNext, onPrevious }) => {
  const { selectedVehicleId } = useLayoutContext();
  const { getValues } = useFormContext<PartnerTransfersFormValues>();

  const [advanceSubscriptions] =
    api.partnerTransfers.getAdvanceSubscriptions.useSuspenseQuery(
      {
        partnerTransferId,
        vehicleId: selectedVehicleId ?? '',
      },
      {
        staleTime: 0,
        gcTime: 0,
      },
    );

  const transferDate = getValues('transferDate') ?? new CalendarDay(new Date());

  return (
    <AdvanceSubscriptionsContent
      partnerTransferId={partnerTransferId}
      transferDate={transferDate}
      advanceSubscriptions={advanceSubscriptions.map((advanceSubscription) => ({
        ...advanceSubscription,
        newInvestorBreakdown: advanceSubscription.newInvestorBreakdown ?? [],
      }))}
      baseCurrency={baseCurrency}
      onNext={onNext}
      onPrevious={onPrevious}
    />
  );
};

export default TransferAdvanceSubscriptions;
